import { Card, ListGroup, Row, Col } from "react-bootstrap"

const OrderFocus = ({ data }) => {
  if (!data) return <div>Select a row for more details</div>
  if (typeof data === "string") return <div>{data}</div>
  return (
    <Card className='aging-info-container'>
      <ListGroup variant='flush'>
        <ListGroup.Item>
          <Row>
            <Col md={4}>
              <strong>Order Number:</strong> {data.order_no}
            </Col>
            <Col md={4}>
              <strong>Sales: </strong>
              {data.sales_person}
            </Col>
            <Col md={4}>
              <strong>Operations: </strong>
              {data.sales_man}
            </Col>
          </Row>
        </ListGroup.Item>
        <ListGroup.Item>
          <Row>
            <Col md={4}>
              <strong>Amount: </strong>${data.amount}
            </Col>
            <Col md={4}>
              <strong>Entry Date: </strong>
              {data.entry_date}
            </Col>
            <Col md={4}>
              <strong>Due Date: </strong>
              {data.due_date}
            </Col>
          </Row>
        </ListGroup.Item>
        <ListGroup.Item>
          <Row>
            <Col xs={12} md={6}>
              <strong>Pickup Date: </strong>
              {data.pickup_date}
            </Col>
            <Col>
              <strong>Deliver Date: </strong>
              {data.delivery_date}
            </Col>
          </Row>
        </ListGroup.Item>
        <ListGroup.Item>
          <Row>
            <Col xs={12} md={6}>
              <strong>Pickup At: </strong>
              {data.deliver_to}
            </Col>
            <Col>
              <strong>Deliver To: </strong>
              {data.pickup_at}
            </Col>
          </Row>
        </ListGroup.Item>
        <ListGroup.Item>
          <Row>
            <Col xs={12} md={6}>
              <strong>Shipper: </strong>
              {data.shipper_name}
            </Col>
            <Col>
              <strong>Consignee: </strong>
              {data.consignee_name}
            </Col>
          </Row>
        </ListGroup.Item>
        <ListGroup.Item>
          <Row>
            <Col>
              <strong>Bill To: </strong>
              {data.bill_to}
            </Col>
            <Col>
              <strong>Vehicle:</strong> {data.vehicle_size}
            </Col>
          </Row>
        </ListGroup.Item>
        <ListGroup.Item>
          <Row>
            <Col>
              <strong>Units:</strong> {data.units}
            </Col>
            <Col>
              <strong>Weight:</strong> {data.weight}
            </Col>
            <Col>
              <strong>Width:</strong> {data.width}
            </Col>
            <Col>
              <strong>Height:</strong> {data.height}
            </Col>
            <Col>
              <strong>Length:</strong> {data.total_length}
            </Col>
            <Col>
              <strong>Stackable:</strong> {data.stackable}
            </Col>
          </Row>
        </ListGroup.Item>
      </ListGroup>
    </Card>
  )
}

export default OrderFocus
